module.exports = __webpack_public_path__ + "img/CG.7de2ec7e.svg";